import ChickenLollipop from "../assets/chops/Chicken Lollipop.png";
import ChickenWings from "../assets/chops/Chicken Wings.png";
import Gizdodo from "../assets/chops/Gizdodo.png";
import MeatPie from "../assets/chops/Meat Pie.png";
import MiniSausageRolls from "../assets/chops/Mini Sausage Rolls.png";
import PepperedGizzard from "../assets/chops/Peppered Gizzard.png";
import PepperedSnail from "../assets/chops/Peppered Snail.png";
import Pizza from "../assets/chops/Pizza.png";
import PuffPuff from "../assets/chops/Puff Puff.png";
import Samosa from "../assets/chops/Samosa.png";
import SpringRolls from "../assets/chops/Spring Rolls.png";

import Apple from "../assets/fruits/apple.png";
import Avocado from "../assets/fruits/avocado.png";
import Banana from "../assets/fruits/banana.png";
import Cherry from "../assets/fruits/cherry.png";
import Coconut from "../assets/fruits/coconut.png";
import Date from "../assets/fruits/date.png";
import Grape from "../assets/fruits/grape.png";
import Mango from "../assets/fruits/mango.png";
import Pawpaw from "../assets/fruits/pawpaw.png";
import Pineapple from "../assets/fruits/pineapple.png";
import Soursop from "../assets/fruits/soursop.png";
import Tangerine from "../assets/fruits/tangerine.png";
import Watermelon from "../assets/fruits/watermelon.png";

import normalizeName from "../utils/normalizeName";

const media = [
  { name: "Chicken Lollipop", image: ChickenLollipop, category: "chops" },
  { name: "Chicken Wings", image: ChickenWings, category: "chops" },
  { name: "Gizdodo", image: Gizdodo, category: "chops" },
  { name: "Meat Pie", image: MeatPie, category: "chops" },
  { name: "Mini Sausage Rolls", image: MiniSausageRolls, category: "chops" },
  { name: "Peppered Gizzard", image: PepperedGizzard, category: "chops" },
  { name: "Peppered Snail", image: PepperedSnail, category: "chops" },
  { name: "Pizza", image: Pizza, category: "chops" },
  { name: "Puff Puff", image: PuffPuff, category: "chops" },
  { name: "Samosa", image: Samosa, category: "chops" },
  { name: "Spring Rolls", image: SpringRolls, category: "chops" },
  { name: "Apple", image: Apple, category: "fruits" },
  { name: "Avocado", image: Avocado, category: "fruits" },
  { name: "Banana", image: Banana, category: "fruits" },
  { name: "Cherry", image: Cherry, category: "fruits" },
  { name: "Coconut", image: Coconut, category: "fruits" },
  { name: "Date", image: Date, category: "fruits" },
  { name: "Grape", image: Grape, category: "fruits" },
  { name: "Mango", image: Mango, category: "fruits" },
  { name: "Pawpaw", image: Pawpaw, category: "fruits" },
  { name: "Pineapple", image: Pineapple, category: "fruits" },
  { name: "Soursop", image: Soursop, category: "fruits" },
  { name: "Tangerine", image: Tangerine, category: "fruits" },
  { name: "Watermelon", image: Watermelon, category: "fruits" },
];

export const IMAGE_BY_NAME = {};
export const CATEGORY_BY_NAME = {};

media.forEach((item) => {
  const key = normalizeName(item.name);
  IMAGE_BY_NAME[key] = item.image;
  CATEGORY_BY_NAME[key] = item.category;
});
